"use strict";
// This icon file is generated automatically.
Object.defineProperty(exports, "__esModule", { value: true });
var LeftOutlined = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M654.89 187.37a48 48 0 00-67.65 5.62L378.41 439.64a112 112 0 000 144.75l208.83 246.62a48 48 0 0073.27-62.04L451.68 522.36a16 16 0 010-20.68l208.83-246.67a48 48 0 00-5.62-67.64z" } }] }, "name": "left", "theme": "outlined" };
exports.default = LeftOutlined;
